import { defineMessages } from 'react-intl';

export const messages: {
	searchAppsPlaceholder: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	searchAppsPlaceholder: {
		id: 'navigation.ribbon.navigation-ribbon.more-apps.search-apps.placeholder',
		description:
			'Placeholder text for the search apps input in the more apps component in the navigation ribbon.',
		defaultMessage: 'Search apps',
	},
});
